import { createContext, useContext, type ReactNode } from "react";

/**
 * „Hilf mir bei dieser Seite" — von überall erreichbar.
 *
 * Das Fenster hängt im Layout, die Überschrift jeder Seite steht in einem
 * gemeinsamen Baustein (ui/PageHeader), und dazwischen liegt der halbe
 * Komponentenbaum. Eine Durchreiche durch jede Seite wäre ein Parameter in
 * dreißig Dateien für einen Klick.
 *
 * Also ein Kontext mit genau einer Funktion. Ohne Anbieter tut sie nichts —
 * so bleibt PageHeader auch außerhalb der Anwendung brauchbar (im
 * Prüfgerüst zum Beispiel).
 */
type Hilfe = {
  /** Öffnet die Hilfe; ohne Pfad die zur Seite, auf der man steht. */
  oeffnen: (pfad?: string) => void;
};

const Kontext = createContext<Hilfe>({ oeffnen: () => {} });

export function HilfeProvider({ oeffnen, children }: Hilfe & { children: ReactNode }) {
  return <Kontext.Provider value={{ oeffnen }}>{children}</Kontext.Provider>;
}

export function useHilfe(): Hilfe {
  return useContext(Kontext);
}
